import React, { FC, useState } from "react";
import classNames from "classnames";
import {
  Benefits_benefitItemsCollection_items,
} from "../../../../__generated__/graphql";
import TextFieldsV2 from "../TextFieldsV2";
import SmallGridCard from "./SmallGridCard";
import styles from "./SmallGrid.module.css";

type SmallGridProps = {
  title?: string | null;
  text?: string | null;
  items: Benefits_benefitItemsCollection_items[];
};

const SmallGrid: FC<SmallGridProps> = ({ title, text, items }) => {
  const [expanded, setExpanded] = useState(false);
  const collapsible = items.length > 4;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.header}>
          <TextFieldsV2 title={title} text={text} center gutterBottom={5} />
        </div>
        <div
          className={classNames(
            styles.gridWrapper,
            collapsible && !expanded && styles.gridWrapperCollapsed
          )}
        >
          <div className={styles.grid}>
            {items.map((item) => (
              <SmallGridCard
                key={item.title}
                title={item.title}
                description={item.description ?? null}
                image={item.image ?? null}
              />
            ))}
          </div>
          {collapsible && !expanded && (
            <>
              <div className={styles.gradient} />
              <button
                className={styles.readMoreButton}
                onClick={() => setExpanded(true)}
              >
                Read more
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default SmallGrid;
